export interface ScoringMethod {
    type: ScoringMethodType
}

export enum ScoringMethodType {
    StrokePlay = "StrokePlay",
    Stableford = "Stableford"
}